import * as React from 'react';
import { TooltipHost, Toggle, getTheme, IToggleStyles } from '@fluentui/react';
import { AdminContext } from 'Store/Admin';

export interface ConfigCheckboxProps {
  id: string;
  label: string;
  value: boolean;
  tooltip: string;
  className: string;
  describedBy?: string;
}

export const ConfigCheckbox: React.FC<ConfigCheckboxProps> = props => {
  const { palette, fonts } = getTheme();
  const toggleStyle: Partial<IToggleStyles> = {
    text: {
      fontFamily: fonts.mediumPlus.fontFamily,
      fontSize: fonts.mediumPlus.fontSize,
      lineHeight: fonts.mediumPlus.lineHeight
    },
    root: {
      marginTop: 7,
      selectors: {
        '& label': {
          marginLeft: 9,
          minWidth: 38,
          fontFamily: fonts.mediumPlus.fontFamily,
          color: palette.neutralDark
        }
      }
    }
  };

  const { dispatch } = React.useContext(AdminContext);
  const [value, setValue] = React.useState<boolean>(props.value);
  const onComponentChange = (checked?: boolean): void => {
    if (checked === undefined) {
      return;
    }
    setValue(checked);

    // todo, remove this if/else map and just pass in the dispatch type
    if (props.id == 'moderatorFeedbackCommentOptional') {
      dispatch({
        type: 'MODERATOR_FEEDBACK_COMMENT_OPTIONAL',
        payload: checked
      });
    } else if (props.id == 'isDefaultBlur') {
      dispatch({
        type: 'UPDATE_UXPREFERENCES_BLUR',
        payload: checked
      });
    } else if (props.id == 'NOT_ASSIGNABLE') {
      dispatch({
        type: 'NOT_ASSIGNABLE',
        payload: checked
      });
    } else if (props.id == 'isDefaultGrayscale') {
      dispatch({
        type: 'UPDATE_UXPREFERENCES_DESATURATE',
        payload: checked
      });
    } else if (props.id == 'isDefaultFlipped') {
      dispatch({
        type: 'UPDATE_UXPREFERENCES_FLIP',
        payload: checked
      });
    } else if (props.id == 'isTextBlurred') {
      dispatch({
        type: 'UPDATE_UXPREFERENCES_TEXT_BLUR',
        payload: checked
      });
    } else if (props.id == 'showReportContext') {
      // todo: add in dispatch
    }
    dispatch({
      type: 'IS_UPDATED',
      payload: true
    });
  };

  return (
    <TooltipHost content={props.tooltip}>
      <Toggle
        className={props.className}
        id={props.id}
        label={props.label}
        aria-describedby={props.describedBy}
        inlineLabel
        checked={value}
        onChange={(_, checked?: boolean): void => onComponentChange(checked)}
        styles={toggleStyle}
      />
    </TooltipHost>
  );
};
